import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import { userTypes } from '@data/Users'
import { useButtonWidth } from '@services/layout'
import TextInput from '@components/Form/TextInput'
import SelectInput from '@components/Form/SelectInput'
import RequiredText from '@components/Form/RequiredText'
import MessageModal from '@components/Modals/MessageModal'
import { FormRow } from '@appearance/styled'
import api from '@services/api'
import {
    PageHeader,
    FormWrapper,
    SubmitBtnContainer,
    SubmitBtn,
} from '@appearance/styled'
import i18n from '@localization/i18n'

export default () => {
    const history = useHistory()
    const buttonWidth = useButtonWidth()
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [memberId, setMemberId] = useState('')
    const [id, setId] = useState('')
    const [choreographerType, setChoreographerType] = useState('')
    const [cellularNumber, setCellularNumber] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [address, setAddress] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [firstNameValid, setFirstNameValid] = useState(null)
    const [lastNameValid, setLastNameValid] = useState(null)
    const [memberIdValid, setMemberIdValid] = useState(null)
    const [idValid, setIdValid] = useState(true)
    const [choreographerTypeValid, setChoreographerTypeValid] = useState(true)
    const [cellularNumberValid, setCellularNumberValid] = useState(true)
    const [phoneNumberValid, setPhoneNumberValid] = useState(true)
    const [addressValid, setAddressValid] = useState(true)
    const [emailValid, setEmailValid] = useState(null)
    const [passwordValid, setPasswordValid] = useState(null)
    const [confirmPasswordValid, setConfirmPasswordValid] = useState(null)
    const [error, setError] = useState(null)
    const [showDoneModal, setShowDoneModal] = useState(false)
    const [showErrorModal, setShowErrorModal] = useState(false)

    useEffect(() => {
        setError(null)
        setErrorPerField(firstNameValid, i18n.t('signup.error_first_name'))
        setErrorPerField(lastNameValid, i18n.t('signup.error_last_name'))
        setErrorPerField(idValid, i18n.t('signup.error_id'))
        setErrorPerField(
            choreographerTypeValid,
            i18n.t('signup.error_instructor')
        )
        setErrorPerField(cellularNumberValid, i18n.t('signup.error_cell_num'))
        setErrorPerField(phoneNumberValid, i18n.t('signup.error_phone'))
        setErrorPerField(addressValid, i18n.t('signup.error_address'))
        setErrorPerField(emailValid, i18n.t('signup.error_email'))
        setErrorPerField(passwordValid, i18n.t('signup.error_password'))
        setErrorPerField(
            confirmPasswordValid,
            i18n.t('signup.error_verify_password')
        )
    }, [
        firstNameValid,
        lastNameValid,
        idValid,
        choreographerTypeValid,
        cellularNumberValid,
        phoneNumberValid,
        addressValid,
        emailValid,
        passwordValid,
        confirmPasswordValid,
        i18n.locale,
    ])

    const setErrorPerField = (field, error) => {
        if (field === false) {
            setError(error)
        }
    }

    const formValid = () =>
        firstNameValid &&
        lastNameValid &&
        idValid &&
        choreographerTypeValid &&
        cellularNumberValid &&
        phoneNumberValid &&
        addressValid &&
        emailValid &&
        passwordValid &&
        confirmPasswordValid

    const doSubmit = () => {
        if (formValid()) {
            console.log(
                'signup',
                email,
                firstName,
                id,
                lastName,
                choreographerType,
                memberId,
                cellularNumber,
                phoneNumber,
                address,
                password
            )

            api.signup(
                email,
                password,
                firstName,
                id,
                lastName,
                choreographerType,
                memberId,
                cellularNumber,
                phoneNumber,
                address
            ).subscribe(
                (res) => {
                    // console.log('signup response', res)
                    setShowDoneModal(true)
                },
                (error) => {
                    setShowErrorModal(true)
                    console.log('signup error', error)
                }
            )
        }
    }

    const goToLandPage = () => {
        history.push('/')
    }

    return (
        <WrapperDiv>
            <PageHeader>{i18n.t('signup.title')}</PageHeader>
            <FormWrapper>
                <FormRow>
                    <TextInput
                        text={firstName}
                        label={i18n.t('edit_user.first_name')}
                        onChangeText={setFirstName}
                        onDoneEdit={setFirstNameValid}
                        required={true}
                        width={buttonWidth}
                    />
                    <TextInput
                        text={lastName}
                        label={i18n.t('edit_user.last_name')}
                        onChangeText={setLastName}
                        onDoneEdit={setLastNameValid}
                        required={true}
                        width={buttonWidth}
                    />
                    <TextInput
                        text={memberId}
                        type="number"
                        label={i18n.t('edit_user.membership_number')}
                        onChangeText={setMemberId}
                        onDoneEdit={setMemberIdValid}
                        width={buttonWidth}
                    />
                </FormRow>
                <FormRow>
                    <TextInput
                        text={id}
                        type="number"
                        label={i18n.t('edit_user.id')}
                        onChangeText={setId}
                        onDoneEdit={setIdValid}
                        width={buttonWidth}
                    />
                    <SelectInput
                        value={choreographerType}
                        placeholder={i18n.t('profile.select')}
                        label={i18n.t('edit_user.instructor_type')}
                        onSelect={setChoreographerType}
                        options={userTypes}
                        onError={(error) => setChoreographerTypeValid(!error)}
                        width={buttonWidth}
                    />
                    <TextInput
                        text={cellularNumber}
                        type="number"
                        label={i18n.t('edit_user.cell_number')}
                        onChangeText={setCellularNumber}
                        onDoneEdit={setCellularNumberValid}
                        width={buttonWidth}
                    />
                </FormRow>
                <FormRow>
                    <TextInput
                        text={phoneNumber}
                        type="number"
                        label={i18n.t('edit_user.another_phone')}
                        onChangeText={setPhoneNumber}
                        onDoneEdit={setPhoneNumberValid}
                        width={buttonWidth}
                    />
                    <TextInput
                        text={address}
                        label={i18n.t('edit_user.address')}
                        onChangeText={setAddress}
                        onDoneEdit={setAddressValid}
                        width={buttonWidth}
                    />
                    <TextInput
                        text={email}
                        type="email"
                        label={i18n.t('signup.email')}
                        onChangeText={setEmail}
                        onDoneEdit={setEmailValid}
                        required={true}
                        width={buttonWidth}
                    />
                </FormRow>
                <FormRow>
                    <TextInput
                        text={password}
                        type="password"
                        // label={'סיסמה'}
                        label={i18n.t('signup.password')}
                        onChangeText={setPassword}
                        onDoneEdit={setPasswordValid}
                        width={buttonWidth}
                        required={true}
                        isCreatePassword
                    />
                    <TextInput
                        text={confirmPassword}
                        comparisonText={password}
                        type="password"
                        label={i18n.t('signup.verify_password')}
                        onChangeText={setConfirmPassword}
                        onDoneEdit={setConfirmPasswordValid}
                        width={buttonWidth}
                        required={true}
                        isCreatePassword
                    />
                </FormRow>
                <FormRow>
                    <RequiredText />
                </FormRow>
                <SubmitBtnContainer>
                    <SubmitBtn onClick={doSubmit} disabled={!formValid()}>
                        {i18n.t('signup.send_request')}
                    </SubmitBtn>
                </SubmitBtnContainer>
                <FormRow>
                    <ErrorText>{error}</ErrorText>
                </FormRow>
            </FormWrapper>
            <MessageModal
                isOpen={showDoneModal}
                title={i18n.t('signup.request_sent')}
                mainText={i18n.t('signup.on_request_confirmed')}
                onClose={goToLandPage}
            />
            <MessageModal
                isOpen={showErrorModal}
                title={i18n.t('signup.error')}
                mainText={i18n.t('signup.email_taken')}
                onClose={() => setShowErrorModal(false)}
                error
            />
        </WrapperDiv>
    )
}

const ErrorText = styled.span`
    color: red;
    text-align: center;
    width: 100%;
`

const WrapperDiv = styled.div`
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    padding-top: 0px auto;
    margin: 0px auto;
    background-color: #ffffff;
    width: 100%;
    text-align: center;
    & h2 {
        text-align: right;
    }
`
